import { dispatch, getState } from '../../..';
import PumpingStationMotorPoleHelper, { IPumpingStationMotorPole } from '../../../../@types/model/masterData/pumpingStation/motorPole';
import GeneralFunctions from '../../../general/functions';
import MasterDataPumpingStationMotorPoleActions from './actions';

export default class MasterDataPumpingStationMotorPoleFunctions {
    private static listener : undefined | (() => void);


    public static readonly load = async () => {
        if (MasterDataPumpingStationMotorPoleFunctions.listener) return;
        
        dispatch(MasterDataPumpingStationMotorPoleActions.setLoading(true));
        dispatch(MasterDataPumpingStationMotorPoleActions.set([]));

        try {
            MasterDataPumpingStationMotorPoleFunctions.listener = PumpingStationMotorPoleHelper
                .collection()
                .onSnapshot((snapshot : firebase.firestore.QuerySnapshot<IPumpingStationMotorPole>) => {
                    const state = getState().masterData.pumpingStation.motorPole;

                    const list = state.motorPoles.slice();
                
                    const session = getState().auth.session;
                    if (!session) return;

                    // "added" | "removed" | "modified"
                    snapshot.docChanges().forEach((f) => {
                        const item = f.doc.data();
                        const index = list.findIndex(n => n.id === item.id);


                        switch (f.type) {
                            case 'added':
                                list.push(item);
                                break;
                            case 'modified':
                                list.splice(index, 1, item);
                                break;
                            case 'removed':
                                list.splice(index, 1);
                                break;
                        }
                    });

                    dispatch(MasterDataPumpingStationMotorPoleActions.set(list));
                    dispatch(MasterDataPumpingStationMotorPoleActions.setLoading(false));
                }, (ex) => {
                    GeneralFunctions.generalShowError(ex, 'Error loading pumps.');
                    dispatch(MasterDataPumpingStationMotorPoleActions.setLoading(false));
                }, () => {
                    dispatch(MasterDataPumpingStationMotorPoleActions.setLoading(false));
                    MasterDataPumpingStationMotorPoleFunctions.listener = undefined;
                });

        } catch (ex) {
            GeneralFunctions.generalShowError(ex, 'Error loading pumps.');
            dispatch(MasterDataPumpingStationMotorPoleActions.setLoading(false));
        }
    };
}